export const getParticipantProps = (selection) => {
    let firstTeam = selection.homeTeamName;
    let secondTeam = selection.awayTeamName;
    if (selection.isTeamSwap) {
        firstTeam = selection.awayTeamName;
        secondTeam = selection.homeTeamName;
    }
    return {
        phraseFirst: firstTeam || "",
        phraseSecond: secondTeam || ""
    };
};
//# sourceMappingURL=getParticipantProps.js.map